import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorReason, ErrorStatus } from '@tink/core/src/tinkLinkErrorCodes';
import { DirectPaymentDetailsModel } from '../payments/models/payments';
import { PaymentCheckType } from '../payments/DirectPayments/models/payment';
import { CommonError } from './app-state-errors';

export enum PaymentDetailErrorType {
  OTHER = 'OTHER',
}

type PaymentDetails = DirectPaymentDetailsModel;

type PaymentDetailsState = {
  data?: PaymentDetails;
  error?: CommonError;
  doublePaymentCheckLoading: boolean;
  duplicatePaymentState?: PaymentCheckType;
};

const initialState: PaymentDetailsState = {
  doublePaymentCheckLoading: false,
  data: undefined,
  error: undefined,
};

export const paymentDetailsSlice = createSlice({
  name: 'paymentDetails',
  initialState,
  reducers: {
    getPaymentDetailsStart: (state) => {
      state.data = undefined;
      state.error = undefined;
    },
    getPaymentDetailsSuccess: (state, action: PayloadAction<PaymentDetails>) => {
      state.data = action.payload;
      state.error = undefined;
    },
    setPaymentDetailsFailure: (state) => {
      state.data = undefined;

      state.error = {
        errorStatus: ErrorStatus.INTERNAL_ERROR,
        errorReason: ErrorReason.REQUEST_FAILED_FETCH_PAYMENT_INFO,
      };
    },
    getDuplicatePaymentStart: (state) => {
      state.doublePaymentCheckLoading = true;
    },
    getDuplicatePaymentSuccess: (state) => {
      state.doublePaymentCheckLoading = false;
    },
    getDuplicatePaymentFailure: (state, action: PayloadAction<PaymentCheckType>) => {
      state.doublePaymentCheckLoading = false;
      state.duplicatePaymentState = action.payload;
    },
  },
});

export const {
  getPaymentDetailsStart,
  getPaymentDetailsSuccess,
  setPaymentDetailsFailure,
  getDuplicatePaymentStart,
  getDuplicatePaymentSuccess,
  getDuplicatePaymentFailure,
} = paymentDetailsSlice.actions;
